import { Colors, Language, Lightning, Router } from '@lightningjs/sdk'
import Button from '../components/buttons/Button'
import AlbumCover from '../components/coverItems/AlbumCover'
import PodcastEpisodeItem from '../components/coverItems/PodcastEpisodeItem'
import LargeText from '../components/LargeText'
import EpisodeList from '../components/lists/EpisodeList'
import { cleanHtml } from '../lib/AppHelpers'
import { appSettings } from '../lib/AppSettings'
import ImageItemWrapper from '../lib/ui/helpers/ImageItemWrapper'

export default class PodcastDetail extends Lightning.Component {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      rect: true,
      color: Colors('PageBG').get(),
      Album: { w: 540, h: 540, x: 260, y: 117, pivot: 0, type: AlbumCover },
      InfoWrapper: {
        w: 540,
        h: 405,
        x: 260,
        y: 677,
        Title: {
          w: 540,
          h: 92,
          color: Colors('white').get(),
          text: {
            text: this.bindProp('title'),
            fontSize: 35,
            fontFace: 'OpenSansBold',
            lineHeight: 45,
            maxLines: 2,
            textOverflow: 'ellipsis',
          },
        },
        ByName: {
          w: 540,
          h: 34,
          y: 95,
          color: Colors('white').get(),
          text: {
            text: this.bindProp('byName'),
            fontSize: 25,
            lineHeight: 40,
            fontFace: 'OpenSansLight',
          },
        },
        DescrWrapper: {
          w: 580,
          h: 85,
          y: 135,
          DescrSmall: {
            w: 540,
            y: 0,
            color: Colors('white').get(),
            alpha: 1,
            text: {
              text: this.bindProp('descrSmall'),
              fontSize: 28,
              lineHeight: 40,
              fontFace: 'OpenSansRegular',
              maxLines: 2,
              textOverflow: 'ellipsis',
            },
          },
          DescrLarge: {
            x: -40,
            w: 540,
            h: 390,
            alpha: 0.001,
            type: LargeText,
            clipbox: false,
          },
        },
      },
      Readmore: {
        w: 200,
        h: 60,
        x: 260,
        y: 927,
        type: Button,
        buttonText: Language.translate('Readmore'),
        padding: 5,
      },
      EpisodesList: {
        x: 968,
        y: 116,
        w: 800,
        h: 915,
        type: EpisodeList,
        direction: 'vertical',
        autoResize: false,
        spacing: 30,
        scrollOffset: 40,
        scrollTransition: {
          duration: 0.6,
          timingFunction: 'cubic-bezier(.2,0,0,1.015)',
        },
        signals: { indexChanged: true },
      },
    }
  }
  historyState(params) {
    if (params) {
      if (params.mainIndex) {
        this.tag('EpisodesList').index = params.mainIndex
      }
    } else {
      return {
        mainIndex: this.tag('EpisodesList').index,
      }
    }
  }

  set items(data) {
    this._item = data
    this.episodes = this._item.episodes

    this._brand = appSettings.currentBrand

    const { title, imageUrl: image, itunesAuthor } = this._item

    this.patch({
      pageBG: this._brand.background,
      title: title,
      byName: `${Language.translate('By')} ${itunesAuthor}`,
      descrSmall: cleanHtml(this._item.description),
      Album: { itemBg: image }, // TODO
    })

    this.tag('DescrLarge').detailtext = cleanHtml(this._item.description)

    this.tag('EpisodesList').items = this.episodes.map((episode, idx) => {
      return {
        ref: `Episode-${episode.id}`,
        w: 800,
        h: idx === 0 ? 240 : 195,
        sizes: { h1: 195, h2: 240 },
        type: ImageItemWrapper,
        itemType: PodcastEpisodeItem,
        item: episode,
        albumImage: image,
      }
    })

    this._setState('EpisodesList')
  }

  pageTransition() {
    return 'fade'
  }

  _init() {
    this._descrCollaps = true

    this.mnuIdx = 3

    this.widgets['sidemenu'].activeMenuItem = this.mnuIdx

    this.tag('DescrSmall').on('txLoaded', () => {
      this.largeTextDims = this.tag('DescrLarge').dimensions
      this._showScroller = this.largeTextDims.height >= 400

      this.tag('Readmore').visible =
        this.tag('DescrSmall').finalH > 100 ||
        this.tag('DescrSmall').text.source.renderInfo.moreTextLines
    })

    this._setState('Idle')
  }

  _active() {
    this._setState('EpisodesList')
  }
  playbackError() {
    this.widgets.errorbox.alpha = 1
    this.widgets.errorbox.notify({
      type: 'playbackStopped',
      Notification: true,
    })
    Router.focusWidget('ErrorBox')
  }
  _inactive() {
    this.stage.gc()
  }

  _startReadMore(show) {
    let duration = show === true ? 0.4 : 0.3,
      delay = show === true ? 0.1 : 0.2,
      albumScale = show === true ? 0.5 : 1,
      infoWrapperY = show === true ? 397 : 677,
      scrollerAlpha = show === true ? 1 : 0,
      moreButtonY = show === true ? 965 : 927,
      moreButtonTxt =
        show === true ? Language.translate('Readless') : Language.translate('Readmore'),
      descrWrapperH = show === true ? 400 : 85,
      descrSwitch = show === true ? 1 : 0

    if (this._showScroller === false) {
      scrollerAlpha = 0
    }
    this.tag('DescrLarge').setScrollerAlpha = scrollerAlpha

    this.patch({
      Album: {
        smooth: { scale: [albumScale, { delay: delay, duration: duration }] },
      },
      InfoWrapper: {
        smooth: { y: [infoWrapperY, { delay: delay, duration: duration }] },
        DescrWrapper: {
          smooth: { h: [descrWrapperH, { delay: delay, duration: duration }] },
          DescrLarge: {
            smooth: {
              alpha: [descrSwitch, { delay: delay, duration: duration }],
            },
          },
          DescrSmall: {
            smooth: {
              alpha: [!descrSwitch, { delay: delay, duration: duration }],
            },
          },
        },
      },
      Readmore: {
        smooth: {
          y: [moreButtonY, { delay: delay, duration: duration }],
          buttonText: [moreButtonTxt, { delay: 0.3, duration: 0 }],
        },
      },
    })

    this._descrCollaps = show !== true
  }

  _focus() {
    this.tag('EpisodesList')._reposition()
    this._setState('EpisodesList')
  }

  static _states() {
    return [
      class Idle extends this {},

      class EpisodesList extends this {
        $enter() {
          this.tag('EpisodesList')._reposition()
        }
        $exit() {
          this.tag('EpisodesList').unfocusList()
        }

        _handleLeft() {
          this._setState('MoreButton')
        }

        _handleEnter() {
          const id = this.tag('EpisodesList').episodeId

          Router.navigate(`podcasts/episodes/${id}`, { autoPlay: false })
        }

        _getFocused() {
          return this.tag('EpisodesList')
        }
      },

      class MoreButton extends this {
        _handleUp() {
          this._handleLeft()
        }

        _handleLeft() {
          if (this._descrCollaps === false) {
            if (this._showScroller === true) {
              this._setState('DescrLarge')
            } else {
              Router.focusWidget('SideMenu')
            }
          } else {
            Router.focusWidget('SideMenu')
          }
        }

        _handleRight() {
          this._setState('EpisodesList')
        }

        _handleEnter() {
          if (this._descrCollaps === true) {
            this._startReadMore(true)

            if (this._showScroller === true) {
              this._setState('DescrLarge')
            }
          } else {
            this._startReadMore(false)
          }
        }

        _getFocused() {
          return this.tag('Readmore')
        }
      },

      class DescrLarge extends this {
        _handleLeft() {
          Router.focusWidget('SideMenu')
        }

        _handleRight() {
          this._setState('MoreButton')
        }
        _handleDown() {
          this._setState('MoreButton')
        }

        _getFocused() {
          return this.tag('DescrLarge')
        }
      },
    ]
  }
}
